export default "__VITE_ASSET__Dp$sdR5v__"